module.exports = __webpack_public_path__ + "static/media/MGOOGL-UST.9d7270f8.svg";